import { render, staticRenderFns } from "./DateDisplay.vue?vue&type=template&id=3037aae2&"
import script from "./DateDisplay.vue?vue&type=script&lang=ts&"
export * from "./DateDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports